<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ service.name }}
        </h1>
        <h1>
          {{ $tc('models.servicePostalCode', 2) }}
          <v-btn color="primary" @click="save" outline :loading="loading" :disabled="loading" v-if="inputFile"> {{ $t('save') }} </v-btn>
          <v-btn color="primary" outline @click="back"> {{ $t('back') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-alert :value="true" color="error" icon="warning" outline v-html="$t('importServicePostalCodeAlert')"></v-alert>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-text-field :label="$t('selectFile')" @click="pickFile" v-model="filename" prepend-icon="attach_file"></v-text-field>
                <input type="file" style="display: none" ref="file" accept="*/*" @change="onFilePicked">
              </v-flex>

              <v-flex xs12 md4>
                <v-select v-model="countryId"
                          :items="countries"
                          item-value="id"
                          item-text="name"
                          :label="$tc('models.country')"
                          v-validate="'required'"
                          :error-messages="errors.collect('country_id')"
                          data-vv-name="country_id"
                          :data-vv-as="$tc('models.country')"
                          required
                          clearable
                          ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Country from '@/client/country'
import Service from '@/client/service'
import Zone from '@/client/zone'
import ServicePostalCode from '@/client/service-postal-code'

export default {
  name: 'ServicePostalCodeImportView',

  props: {},

  data () {
    return {
      filename: '',
      inputFile: '',
      countryId: '',
      service: {},
      countries: [],
      model: '',
      loading: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    onFilePicked (e) {
      this.loading = true
      this.errors.clear()

      this.inputFile = e.target.files[0]
      this.filename = this.inputFile.name
      this.loading = false
    },

    pickFile () {
      this.$refs.file.click()
    },

    async fetch () {
      this.loading = true
      if (this.$route.path.includes('zone')) {
        this.model = 'zone'
        this.zone = await Zone.findOne(this.$route.params.zoneId)
      }
      else {
        this.model = 'service'
        this.service = await Service.findOne(this.$route.params.serviceId)
      }
      this.countries = await Country.all({ per_page: 2000, order: 'name ASC', fast_search: true })
      this.countryId = this.countries.find(o => o.name === 'México' || o.name === 'Mexico').id;
      this.loading = false
    },

    async save () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }
      this.loading = true
      try {
        const formData = new FormData()
        formData.append('files[]', this.inputFile)
        formData.append(`${this.model}_id`, this[this.model]['id'])
        formData.append('country_id', this.countryId)
        await ServicePostalCode.uploadFile(formData)
        this.setNotification({
          color: 'success',
          message: this.$t('servicePOstalCodeImportSuccess')
        })
        this.back()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    }
  },

  watch: {
  },

  async mounted () {
    this.fetch()
  }
}
</script>
